import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { BrandMark } from './BrandMark';

type Props = { onNavigate?: (() => void) | undefined; compact?: boolean };

export function Brand({ onNavigate, compact = false }: Props) {
  return (
    <Stack
      component={RouterLink}
      to="/"
      onClick={onNavigate}
      direction="row"
      aria-label="Research Assistant, go to Ask Research"
      sx={{ alignItems: 'center', gap: 1.25, color: 'inherit', textDecoration: 'none', borderRadius: 1 }}
    >
      <BrandMark />
      <Stack sx={{ minWidth: 0 }}>
        <Typography variant="h4" component="span" noWrap sx={{ lineHeight: 1.2 }}>Research Assistant</Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.3, display: compact ? { xs: 'none', sm: 'block' } : 'block' }}>OCBC Global Markets</Typography>
      </Stack>
    </Stack>
  );
}
